/**
createPdfDrawingTemplate(input: {
  name: "filename",
  fileKey: "someurl",
  description: "file-description"
}) {
  */
const createPdfDrawingTemplate = `
 mutation createPdfDrawingTemplate ($input: createPdfDrawingTemplateInput!) {
   createPdfDrawingTemplate(input: $input) {
     errors: errors_2 { code message }
     status
   }
 }
`
const createWkhtmltopdfTemplate = `
 mutation createWkhtmltopdfTemplate ($input: createWkhtmltopdfTemplateInput!) {
  createWkhtmltopdfTemplate(input: $input) {
     errors: errors_2 { code message }
     status
   }
 }
`

/**
updatePdfDrawingTemplate
 templateId: "some-template-id"
 drawingId: "some-drawing-id"
*/
const updatePdfDrawingTemplate = `
mutation updatePdfDrawingTemplate(
 $templateId: String!
 $input: createPdfDrawingTemplateInput!
) {
 updatePdfDrawingTemplate(
   templateId: $templateId
   input: $input
 ) {
   errors: errors_2 { code message }
   status
 }
}
`

const updateWkhtmltopdfTemplate = `
mutation updateWkhtmltopdfTemplate(
 $templateId: String!
 $input: updateWkhtmltopdfTemplateInput!
) {
  updateWkhtmltopdfTemplate(
   templateId: $templateId
   input: $input
 ) {
   errors: errors_2 { code message }
   status
 }
}
`

/**
addPdfDrawing(
 templateId: "some-id"
 input: {
   page: 1,
   liquidSource: "",
   point1: { x: 0, y: 0},
   point2: { x: 1, y: 1}
 }
) {
*/
const createPdfDrawing = `
mutation createPdfDrawing(
 $templateId: String!
 $input: addPdfDrawingInput!
 ) {
  addPdfDrawing(
   templateId: $templateId
   input: $input
 ) {
   errors: errors_2 { code message }
   status
 }
}
`

/**
updatePdfDrawing(
 templateId: "some-id"
 drawingId: "some-drawing-id"
 input: {
   page: 1,
   liquidSource: "",
   point1: { x: 0, y: 0},
   point2: { x: 1, y: 1}
 }
) {
*/
const updatePdfDrawing = `
mutation updatePdfDrawing(
 $templateId: String!
 $drawingId: String!
 $input: updatePdfDrawingInput!
) {
 updatePdfDrawing(
   templateId: $templateId
   drawingId: $drawingId
   input: $input
 ) {
   errors: errors_2 { code message }
   status
 }
}
`

/**
removePdfDrawing(
 templateId: "some-template-id"
 drawingId: "some-drawing-id"
) {
*/
const removePdfDrawing = `
mutation removePdfDrawing(
 $templateId: String!
 $drawingId: String!
) {
 removePdfDrawing(
   templateId: $templateId
   drawingId: $drawingId
 ) {
   errors:  errors_2 { code message }
   status
 }
}
`

/**
 * todo: update this query
 */
const listTemplates = `
query listTemplates(
  $limit: Int
  $skip: Int
  $sort: sortInput
  $where: templateWhereInput
) {
 templates(
   limit: $limit
   skip: $skip
   sort: $sort
   where: $where
  ) {
    totalCount
    list {
      createdAt createdBy { id }
      id
      description
      name
      graphQlQuery
      lastModifiedAt

      ...on pdfDrawingTemplate {
        pdfUrl: fileKey
      }
      ... on emailMjmlTemplate {
        attachmentTemplates {
          attachmentTemplateId
          fileName
          templateId
        }
        attachmentReferences {
          id
          fileName
          filePath
        }
        mjml
        subject
      }
      ... on wkhtmltopdfTemplate {
        html
      }
   }
   totalCount
 }
}
`

const templateWithDrawings = `
fragment drawings on pdfDrawing {
  id
  font { fontStyle, familyName, emSize }
  point1 { x, y }
  point2 { x, y }
  liquidSource
  page
  textAlignment verticalAlignment
}

query listTemplates(
  $limit: Int
  $skip: Int
  $sort: sortInput
  $where: templateWhereInput
) {
 templates(
   limit: $limit
   skip: $skip
   sort: $sort
   where: $where
  ) {
    totalCount
    list {
      createdAt createdBy { id }
      id description name
      lastModifiedAt
      graphQlQuery

      ...on pdfDrawingTemplate {
        drawings { ...drawings }
        pdfUrl: fileKey
        passwordLiquid
      }
      ... on wkhtmltopdfTemplate {
        html
        passwordLiquid
        marginSettings{ top right bottom left }
        headerSettings{ center fontName fontSize html left line right spacing }
        footerSettings{ center fontName fontSize html left line right spacing }
      }
   }
   totalCount
 }
}
`

const createEmailMjmlTemplate = `
 mutation createEmailMjmlTemplate ($input: createEmailMjmlTemplateInput!) {
  createEmailMjmlTemplate(input: $input) {
     errors: errors_2 { code message }
     status
   }
 }
`

const updateEmailMjmlTemplate = `
 mutation updateEmailMjmlTemplate ($templateId: String! $input: updateEmailMjmlTemplateInput!) {
  updateEmailMjmlTemplate(templateId:$templateId input: $input) {
     errors: errors_2 { code message }
     status
   }
 }
`

const deleteTemplate = `
 mutation deleteTemplate ($templateId: String!) {
  deleteTemplate(templateId:$templateId) {
     errors: errors_2 { code message }
     status
   }
 }
`
const listFileTemplates = `
query listFileTemplates($prefix:String) {
  fileListing(prefix:$prefix){
    objectSummaries {
      fileName key lastModifiedAt
    }
    commonPrefixes
  }
}
`

const pdfTemplates = `
  query pdfTemplates(
   $limit: Int
   $skip: Int
   $sort: sortInput
   $where: templateWhereInput
 ) {
  templates(
    limit: $limit
    skip: $skip
    sort: $sort
    where: $where
   ) {
     totalCount
     list {
      id
      name
    }
    totalCount
  }
 }
`

const addEmailAttachmentTemplate = `
 mutation addEmailAttachmentTemplate ($templateId: String! $input: addEmailAttachmentTemplateInput!) {
  addEmailAttachmentTemplate(templateId:$templateId input: $input) {
     errors: errors_2 { code message }
     status
   }
 }
`

const removeEmailAttachmentTemplate = `
 mutation removeEmailAttachmentTemplate ($templateId: String! $attachmentTemplateId: String !) {
  removeEmailAttachmentTemplate(templateId:$templateId attachmentTemplateId: $attachmentTemplateId) {
     errors: errors_2 { code message }
     status
   }
 }
`

const updateEmailAttachmentTemplate = `
 mutation updateEmailAttachmentTemplate ($templateId: String! $input: updateEmailAttachmentTemplateInput!) {
  updateEmailAttachmentTemplate(templateId:$templateId input: $input) {
     errors: errors_2 { code message }
     status
   }
 }
`

const sendNotification = `
mutation sendNotification($input: sendNotificationInput!) {
  sendNotification(input: $input) {
    errors
    status
  }
}
`

const renderEmailMjmlTemplate = `
query renderEmailMjmlTemplate($templateId: String! $input: templateRenderParametersInput){
  renderEmailMjmlTemplate(templateId: $templateId input: $input){
    status
    errors
    value{
      html
    }
  }
}
`

const policies = `
query policies($skip: Int, $limit: Int, $sort: sortInput, $where: policyWhereInput){
  policies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      id

      acceptedOffer {
        premium {
          formattedPrice
          appliedDiscounts{ code }
        }
        product{ name insurer{ name } productId{type plan version} }
      }
      issuerNumber
      holder{
        contacts{ id type value }
      }
      status
      startDate
      endDate
      issueDate
      referrer{ name }
      holder{
        ... on individual { __typename id name }
        ... on company { __typename id name }
      }
    }
  }
}
`

const renderPdfDrawingTemplate = `
query renderPdfDrawingTemplate($templateId: String!, $input: templateRenderParametersInput){
  renderPdfDrawingTemplate(templateId: $templateId input: $input) {
    errors
    status
    value
  }
}
`
const renderWkhtmltopdfTemplate = `
query renderWkhtmltopdfTemplate($templateId: String!, $input: templateRenderParametersInput){
  renderWkhtmltopdfTemplate(templateId: $templateId input: $input) {
    errors
    status
    value
  }
}
`

const query = {
	pdfTemplates,
	listTemplates,
	listFileTemplates,
	policies,
	renderEmailMjmlTemplate,
	templateWithDrawings,
	renderPdfDrawingTemplate,
	renderWkhtmltopdfTemplate
}

const mutation = {
	createPdfDrawingTemplate,
	createWkhtmltopdfTemplate,
	updatePdfDrawingTemplate,
	updateWkhtmltopdfTemplate,

	createPdfDrawing,
	removePdfDrawing,
	updatePdfDrawing,

	createEmailMjmlTemplate,
	updateEmailMjmlTemplate,
	deleteTemplate,
	addEmailAttachmentTemplate,
	removeEmailAttachmentTemplate,
	updateEmailAttachmentTemplate,
	sendNotification
}

export { query, mutation }
